import { Button, MyTableComponent } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

export const PtLine = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   info1: "",
   info2: "",
   info3: "Hizufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hizufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hizufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hizufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hizufugen",
  },
 ]

 const columns = [
  {
   Header: "Name",
   Cell: () => (
    <div className="bg-gray py-2 flex justify-between items-center rounded px-2">
     <input
      className="w-full  outline-none bg-transparent"
      min="0"
      max="999"
      type="number"
      placeholder="0"
     />
    </div>
   ),
  },
  { Header: t("description"), accessor: "info1" },
  {
   Header: t("Devices"),
   accessor: "info2",
  },
  {
   Header: t("action"),
   Cell: ({ row }: any) => (
    <div className="text-light-blue bg-[#bac9ff] py-2 rounded">{row.original.info3}</div>
   ),
  },
 ]

 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center mb-4">
    <div>
     <h1 className="Jakarta-font font-bold text-xl">{t("publicTransportLines")}</h1>
     <p className="Jakarta-font  text-xs font-semibold">
      Hier können Sie den Linien dieser Anlagen Meldestrecken zuordnen
     </p>
    </div>

    <div className="flex lg:flex-row flex-col lg:items-center">
     <div>
      <Button size={"doublexl"}>Forum Gera</Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button size={"doublexl"} color={"gray"}>
       Test Server
      </Button>
     </div>
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3">
     <h1 className="Jakarta-font font-semibold text-lg">{t("publicTransportLines")}</h1>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
  </div>
 )
}
